export function getPharmacyBookingLandingPath(pharmacyId: string): string {
  return `/pharmacy-bookings/${pharmacyId}`;
}

export function getPharmacyBookingEmailPath(pharmacyId: string): string {
  return `/pharmacy-bookings/${pharmacyId}/email`;
}

export function getPharmacyBookingOtpPath(pharmacyId: string): string {
  return `/pharmacy-bookings/${pharmacyId}/otp`;
}

/** OTP 完了後の予約フォーム */
export function getPharmacyBookingFormPath(pharmacyId: string): string {
  return `/pharmacy-bookings/${pharmacyId}/booking`;
}

/** 予約完了画面（管理 URL 表示。詳細は PBI-032） */
export function getPharmacyBookingCompletePath(pharmacyId: string): string {
  return `/pharmacy-bookings/${pharmacyId}/complete`;
}

export function getPharmacyBookingManagePath(managementToken: string): string {
  return `/pharmacy-bookings/manage/${managementToken}`;
}

/** 利用規約・プライバシーポリシー（themis-mis 1 policy。表示専用ページ） */
export function getPharmacyBookingTermsAndPrivacyPath(): string {
  return '/pharmacy-bookings/terms-and-privacy';
}

export function isPharmacyBookingPath(pathname: string): boolean {
  return pathname === '/pharmacy-bookings' || pathname.startsWith('/pharmacy-bookings/');
}

/** 管理 URL。管理トークン認証のみで Orthrus 匿名セッションは不要 */
export function isPharmacyBookingManagePath(pathname: string): boolean {
  return pathname === '/pharmacy-bookings/manage' || pathname.startsWith('/pharmacy-bookings/manage/');
}

/** 予約完了画面。handoff 表示のみで Orthrus 匿名セッションは不要 */
export function isPharmacyBookingCompletePath(pathname: string): boolean {
  return /^\/pharmacy-bookings\/[^/]+\/complete\/?$/.test(pathname);
}

/**
 * 同意文面ページ。personId は不要だが、themis 取得に Orthrus IAT（匿名セッション）が必要。
 * `requiresPharmacyBookingAnonymousSession` の対象に含まれる。
 */
export function isPharmacyBookingTermsAndPrivacyPath(pathname: string): boolean {
  return pathname === '/pharmacy-bookings/terms-and-privacy' || pathname === '/pharmacy-bookings/terms-and-privacy/';
}

/**
 * 薬局予約フローで Orthrus 匿名 PersonID が必要なパス。
 * 管理ページ・完了ページは除外する。
 * 同意文面ページは themis 取得に IAT（＝Orthrus セッション）が必要なため対象に含める。
 */
export function requiresPharmacyBookingAnonymousSession(pathname: string): boolean {
  return (
    isPharmacyBookingPath(pathname) &&
    !isPharmacyBookingManagePath(pathname) &&
    !isPharmacyBookingCompletePath(pathname)
  );
}
